import React, { memo, useMemo } from 'react';
import {
  Breadcrumbs,
  Breadcrumb,
} from '../../interfaces/Breadcrumbs.interface';
import StructuredData from '../StructuredData/StructuredData';

interface BreadcrumbListStructuredDataProps {
  breadcrumbs: Breadcrumbs;
}

const BreadcrumbListStructuredData: React.FC<
  BreadcrumbListStructuredDataProps
> = ({ breadcrumbs }) => {
  const breadcrumbsExcludingHomeRoute = useMemo(() => {
    return breadcrumbs.breadcrumbs.filter(
      (breadcrumb: Breadcrumb) => breadcrumb.slug !== ''
    );
  }, [breadcrumbs]);

  const breadcrumbListStructureData = useMemo(() => {
    const breadcrumbListItems = breadcrumbsExcludingHomeRoute.map(
      (breadcrumb: Breadcrumb, index: number) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: `${process.env.GATSBY_WEBSITE_URL}/${breadcrumb.slug}`,
          name: breadcrumb.label,
        };
      }
    );

    const currentListItem = {
      '@type': 'ListItem',
      position: breadcrumbsExcludingHomeRoute.length + 1,
      name: breadcrumbs.label,
    };

    return {
      '@type': 'BreadcrumbList',
      itemListElement: [...breadcrumbListItems, currentListItem],
    };
  }, [breadcrumbs]);

  return <StructuredData>{breadcrumbListStructureData}</StructuredData>;
};

export default memo(BreadcrumbListStructuredData);
